import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpEventType
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/shared/services/environment.service';
import { TechPubsHttpResponse } from '../models/techpubs-http-response';
import { PlatformService, PlatformType } from 'src/app/shared/services/offline/platform.service';
import { PlatformMethod } from 'src/app/shared/services/offline/platform-methods';
import { HttpFileDownloadService } from 'src/app/shared/services/http-progress-event/http-file-download.service';
import { TechPubsHttpRequest } from '../models/techpubs-http-request';
import { ACCEPTED_MEDIA_TYPES } from '../http-mediatypes/accepted-media-types.enum';
import { JSON_MEDIA_TYPES } from '../http-mediatypes/json-media-types.enum';

@Injectable()
export class MauiInterceptor implements HttpInterceptor {

  private decoder: TextDecoder = new TextDecoder("utf-8");
  private encoder: TextEncoder = new TextEncoder();

  constructor(
    private platformService: PlatformService,
    private environmentService: EnvironmentService,
    private httpFileDownloadService: HttpFileDownloadService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.platformService.platform === PlatformType.MAUI && 
      (request.url.startsWith(this.environmentService.getBackendUrl()) || request.url === this.environmentService.getNetworkServiceEndpoint())) {
      if (request.reportProgress) {
        this.httpFileDownloadService.handleHttpRequest(request);
      }
      let response$: Observable<TechPubsHttpResponse>;
      let mauiRequest: TechPubsHttpRequest; 
      switch (request.method) {
        case "GET":
          response$ = this.platformService.invokePlatformMethod<TechPubsHttpResponse>(PlatformMethod.makeHttpGetRequest, request.url);
          break;
        default:
          mauiRequest = this.createMauiHttpRequest(request);
          response$ = this.platformService.invokePlatformMethod<TechPubsHttpResponse>(PlatformMethod.makeHttpRequest, mauiRequest);
          break;
      }
      return from(response$)
        .pipe(
          map(body => this.createMauiHttpEvent(request, body)),
          tap(
            (event: HttpEvent<any>) => {
              if (request.reportProgress && event.type === HttpEventType.Response) {
                this.httpFileDownloadService.handleHttpRequest(request);
              }
            }
          )
        );
    } else {
      return next.handle(request);
    }
  }

  createMauiHttpEvent<T>(request: HttpRequest<unknown>, response: TechPubsHttpResponse): HttpResponse<T> {
    console.log('request object:', request);
    console.log('response object:', response);

    let body;
    let contentType = response.contentType;
    let mediaType = contentType ? contentType.mediaType : null;

    if (request.responseType !== 'blob' && mediaType && Object.values(ACCEPTED_MEDIA_TYPES).includes(mediaType as ACCEPTED_MEDIA_TYPES)) {
      body = this.decoder.decode(new Uint8Array([...response.content]));
      console.log('body: ', body);
      
      if (Object.values(JSON_MEDIA_TYPES).includes(mediaType as JSON_MEDIA_TYPES)) {
        body = JSON.parse(body);
      }
    } else {
      body = new Blob([response.content.buffer], { type: mediaType});
    }
    console.log('new body: ', body);
    return new HttpResponse({
      body: body,
      status: response.statusCode,
      url: request.url
    });
  }

  createMauiHttpRequest(request: HttpRequest<unknown>): TechPubsHttpRequest {
    let jsonBody = JSON.stringify(request.body);
    let content = this.encoder.encode(jsonBody);
    return {
      url: `${request.url}`,
      httpMethod: `${request.method}`,
      content: content
    };
  }
}
